import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-search-icon',
  templateUrl: './lib-search-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibSearchIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
